export default "__VITE_ASSET__DbycNjou__"